import React, { Component } from "react"
import PropTypes from "prop-types"
import { Alert, Card, CardBody, CardTitle, Col, Container, Label, Row, Modal, ModalBody, ModalHeader } from "reactstrap"
import Select from "react-select"
// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"
import { withTranslation } from "react-i18next"
import firebase from "firebase/app"
import "firebase/auth"
import toastr from "toastr";
import toast, { Toaster } from 'react-hot-toast';



import geohash from "ngeohash";

import cities from "../../common/data/villes.json"
import { GoogleApiWrapper, InfoWindow, Map, Marker } from "google-maps-react"
const LoadingContainer = () => <div>Loading...</div>
// action
import { apiError, registerUser, registerUserFailed } from "../../store/actions"

// Redux
import { connect } from "react-redux"
import { Redirect, Link } from "react-router-dom"

// import images
import profileImg from "../../assets/images/profile-img.png"
import logoImg from "../../assets/images/logo.svg"
import emailInbox from "pages/Email/email-inbox"

class Invitation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email:null,
      disableEmail:false,
      code:null,
      disableCode:false,
      redirectToDashboard:false,
      invitation: null,
      selectedCity: null,
      user: false,
      registrationError: false,
      registrationErrorMsg: "",
      mapmodal: false,
      longitude: null,
      latitude: null,
      userAddress: null,
      userCity: null,
      userState: null,
      addressLoading: false,
      markerTitle: "The marker`s title will appear as a tooltip.",
      markerName: "Medios",
      markerPosition: { lat: 37.778519, lng: -122.40564 }

    }

    // handleValidSubmit
    this.onClickMarker = this.onClickMarker.bind(this)
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.handleSelectCity = this.handleSelectCity.bind(this)
    this.toggleViewModal = this.toggleViewModal.bind(this)
    this.getLocation = this.getLocation.bind(this)
    this.getCoordinates = this.getCoordinates.bind(this)
    this.getUserAddress = this.getUserAddress.bind(this)
  }

  onClickMarker(t, map, coord) {
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();

    this.getUserAddress(lat, lng)
    this.setState({

      markerTitle: "",
      markerName: "",
      markerPosition: { lat, lng }

    });

  }
  toggleViewModal = () => {
    //this.getLocation()
    this.setState(prevState => ({
      mapmodal: !prevState.mapmodal,
    }))
  }
  async registerUser(values) {
    try {
      const { invitation } = this.state;

      // Create user with email and password
      const userCredential = await firebase.auth().createUserWithEmailAndPassword(values.email, values.password);
      const currentUser = userCredential.user;
      const uid = currentUser.uid;

      // Set user document in Firestore
      const userDocRef = firebase.firestore().collection("users").doc(uid);
      await userDocRef.set({
        id: invitation.account_id,
        email: values.email,
        uid: uid,
        first_name: invitation.first_name,
        last_name: invitation.last_name,
        createdAt: invitation.createdAt,
        isAdmin: false,
        branchId:invitation.branchId || ""
      });
      const permissions = {
        reservations: { add: true, update: true, delete: true },
        rates: { add: true, update: true, delete: true },
        expenses: { add: true, update: true, delete: true },
        vehicles: { add: true, update: true, delete: true },
        quotes: { add: true, update: true, delete: true },
        maintenance: { add: true, update: true, delete: true },
        tax: { add: true, update: true, delete: true },
        inssurance: { add: true, update: true, delete: true },
        technical_control: { add: true, update: true, delete: true },
        traffic_fines: { add: true, update: true, delete: true },
        clients: { add: true, update: true, delete: true },
        workshops: { add: true, update: true, delete: true },
      };
      
      const permissionsCollectionRef = userDocRef.collection("permissions");
      
      // Loop through the permissions and add each attribute as a document
      for (const [attribute, actions] of Object.entries(permissions)) {
        await permissionsCollectionRef.doc(attribute).set(actions);
      }
      // Update invitation status to "done"
      const invitationDocRef = firebase.firestore().collection("invitations").doc(invitation.id);
      await invitationDocRef.update({
        status: "done"
      });

      // Update staff status to "user" and set isUser to true
      const staffDocRef = firebase.firestore().collection("users").doc(invitation.account_id).collection("staffs").doc(invitation.staff_id);
      await staffDocRef.update({
        status: "user",
        isUser: true,
        userId: uid
      });

      // Success message and state update
      toast.success('User Registered ');
      this.setState({
        user: true,
      });

      return currentUser;
    } catch (error) {
      // Error handling
      toast.error(error.message);
      this.setState({
        registrationError: true,
        registrationErrorMsg: error.message
      });
      throw this._handleError(error);
    }
  }
  async invi(values) {
    try {
      const invitationRef = firebase.firestore().collection('invitations').where('code', '==', values.invitation_code);
      const querySnapshot = await invitationRef.get();

      if (querySnapshot.empty) {
        // Invitation with provided code does not exist
        return null;
      }

      // Loop through the query results (should be only one)
      for (const doc of querySnapshot.docs) {
        const invitationData = doc.data();
      // //console..log(invitationData)
        if (invitationData.email === values.email && invitationData.status === "created") {
          
          this.setState({
            invitation: invitationData
          })
          return invitationData
        }
      }

      // Invitation with provided email not found or status is not 'created'
      return null;
    } catch (error) {
     //console..error("Error checking invitation:", error);
      return null;
    }
  }


  async checkInvitation(values) {
    //console.log(values)
    try {
      const invitationRef = firebase.firestore().collection('invitations').where('code', '==', values.invitation_code);
      const querySnapshot = await invitationRef.get();

      if (querySnapshot.empty) {
        // Invitation with provided code does not exist
        return false;
      }

      // Loop through the query results (should be only one)
      for (const doc of querySnapshot.docs) {
        const invitationData = doc.data();
       //console..log(invitationData)
        if (invitationData.email === values.email && invitationData.status === "created") {
          this.setState({
            invitation: invitationData
          })
          return true;
        }
      }

      // Invitation with provided email not found or status is not 'created'
      return false;
    } catch (error) {
     //console..error("Error checking invitation:", error);
      return false;
    }
  }
  async checkExist(values) {
    try {
      const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(values.email);
      return signInMethods.length > 0;
    } catch (error) {
     //console..error("Error checking email existence:", error);
      // Handle error appropriately, for example:
      throw error;
    }
  }

  // handleValidSubmit
  async handleValidSubmit(event, values) {
    //this.props.registerUser(values)
    this.setState({
      registrationError: false,
      registrationErrorMsg: ""
    })
    //console.log(values)
    //console.log(this.state.invitation)
    try {
      const emailExists = await this.checkExist(values);
      const invitationValid = await this.checkInvitation(values)
      const invi = await this.invi(values);
      //console.log(invi)
      //console.log(emailExists, invitaionValid)
      //console.log(this.state.invitation)
      if (!emailExists && invitationValid && invi !== null) {
        //console.log("this shit is great");
        await this.registerUser(values)
      } else {
        //console.log("sir tqawed");

      }

      if (emailExists) {
        toast.error('An account with the same email already exist')
        this.setState({
          registrationError: true,
          registrationErrorMsg: 'An account with the same email already exist'
        })
      }
      if (!invitationValid) {
        toast.error('The invitation is not valid')
        this.setState({
          registrationError: true,
          registrationErrorMsg: 'The invitation is not valid'
        })
      }
      if (invi === null) {
        toast.error('Error creating account')
        this.setState({
          registrationError: true,
          registrationErrorMsg: 'Error creating account'
        })
      }
    } catch (error) {
     //console..error("Error:", error);
      this.setState({
        registrationError: true,
        registrationErrorMsg: error
      })
    }

    // this.CheckInvitation(values)
    // this.registerUser(values)


  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    const code  = urlParams.get('code');
    //console.log(email,code)
    if(email !==null){
      this.setState({
        email:email,
        disableEmail:true
      })
    }
    if(code !==null){
      this.setState({
        code:code,
        disableCode:true
      })
    }
    


    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        this.setState({ redirectToDashboard: true }); // Redirect to dashboard
      } else {
        // No user is signed in.
        this.setState({ redirectToDashboard: false });
      }
    });
  }
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.getCoordinates, this.handleLocationError)
    } else {
      alert("geolocation is not supported")
    }
  }
  getCoordinates(position) {
   //console..log(position)
    this.setState({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      markerPosition: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
    })
    this.getUserAddress(position.coords.latitude, position.coords.longitude)
  }
  handleLocationError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        toast.error("User denied the request for Geolocation.")
        break;
      case error.POSITION_UNAVAILABLE:
        toast.error("Location information is unavailable.")
        break;
      case error.TIMEOUT:
        toast.error("The request to get user location timed out.")
        break;
      case error.UNKNOWN_ERROR:
        toast.error("An unknown error occurred.")
        break;
      default:
        toast.error("An unknown error occurred.")
    }
  }
  getUserAddress(lat, lng) {
    //console.log("get user address", lat, lng)
    var key = "AIzaSyANuYDpzsSpPUtQHTGJPoBz9EKWelMNNtg"
    this.setState({
      addressLoading: true
    })
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=false&key=${key}`)
      .then(response => response.json())
      .then(data => {
        //console.log(data.results)
        this.setState({
          addressLoading: false
        })
        if (data.results[0]) {

          for (var i = 0; i < data.results.length; i++) {
            if (data.results[i].types[0] === "route") {
              var address = data.results[i].formatted_address;
              //console.log(address)
              this.setState({
                userAddress: address
              })
            };
            if (data.results[i].types[0] === "locality") {
              var city = data.results[i].address_components[0].short_name;
              var state = data.results[i].address_components[1].short_name;
              //console.log(city)
              //console.log(state)
              this.setState({
                userCity: city,
                userState: state,

              })
            };
          };
        };
      }
      )
      .catch(error =>console.log("error" ))
  }
  handleSelectCity = selectedCity => {

    this.setState({ selectedCity: selectedCity })

  }
  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error) {
    // var errorCode = error.code;
    var errorMessage = error.message
    return errorMessage
  }
  render() {
    const {email,code,redirectToDashboard,disableCode,disableEmail}=this.state
   ////console..log(email,disableEmail)
   ////console..log(code,disableCode)
    if (redirectToDashboard) {
      return <Redirect to="/dashboard" />;
    }
   ////console..log(this.state.registrationErrorMsg)
    //console.log(this.state.markerPosition)
    //console.log(this.state.userAddress)
    //console.log(this.state.userCity)
    const villes = []
    const { selectedCity,invitation } = this.state
   ////console..log(invitation)
    cities.map(function (item, i) {
      villes.push({ label: item.ville, value: item.ville })

    })

    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.mapmodal}
          size='md'
        >
          <ModalHeader toggle={this.toggleViewModal} tag="h4">
            Select localisation
          </ModalHeader>
          <ModalBody>
            <Row>

              <Col>
                <Card>
                  <CardBody>

                    <h4 className="h4">Address</h4>
                    <Row>
                      <Col >
                        <h6 className="card-title-desc">
                          {this.state.addressLoading ?
                            <i className="bx bx-loader bx-spin bx-md" />
                            :

                            this.state.userAddress || "Address... "
                          }

                        </h6>
                      </Col>

                      <Col className="mb-3 text-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => this.getLocation()}
                        >
                          <i className="bx bx-map font-size-16 align-middle me-2"></i>
                          Current location
                        </button>
                      </Col >
                    </Row>
                    <Row id="gmaps-overlay"
                      className="gmaps "
                      style={{ position: "relative" }}>

                      <Map
                        bootstrapURLKeys={{ key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE" }}
                        google={this.props.google}
                        zoom={5}
                        style={{ width: "100%", height: "100%", borderRadius: '8px' }}
                        onClick={this.onClickMarker}
                        fullscreenControl={false}
                        initialCenter={{

                          lat: 31.7218287,
                          lng: -11.6459998,
                        }}
                        center={{

                          lat: this.state.markerPosition.lat,
                          lng: this.state.markerPosition.lng,
                        }}

                      >
                        <Marker
                          title={this.state.markerTitle}
                          name={this.state.markerName}
                          position={this.state.markerPosition}
                        />
                      </Map>

                    </Row>
                    <Row>
                      <Col className="mt-3">
                        <div className="text-end">

                          <button
                            type="button"
                            className="btn btn-success save-user"
                            onClick={() => this.toggleViewModal()}
                          >
                            Confirm
                          </button>
                        </div>
                      </Col>
                    </Row>

                  </CardBody>
                </Card>
              </Col>
              <Row className="text-center">
                <p className="card-title-desc">
                  This helps clients easily find your agency for pickups and returns.
                </p>
              </Row>
            </Row>




          </ModalBody>
        </Modal>
        <div className="home-btn d-none d-sm-block">
          <a href="https://medios.ma" className="text-dark">
            <i className="bx bx-home h2" />
          </a>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">{this.props.t("Medios Invitation")}</h5>
                          <p>{this.props.t("Access Medios account now.")}</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      <AvForm
                        className="needs-validation"
                        onValidSubmit={this.handleValidSubmit}
                      >
                        {this.state.user && this.state.user ? (

                          <Redirect to='/dashboard' />
                        ) : null}
                        {this.state.registrationError &&
                          this.state.registrationError ? (
                          <Alert color="danger">
                            {this.state.registrationErrorMsg}
                          </Alert>
                        ) : null}

                        <div className="mb-3">
                          <AvField
                            name="email"
                            label={this.props.t("Email")}
                            value={this.state.email || "" }
                            className="form-control"
                            placeholder={this.props.t("Enter email")}
                            type="email"
                            disabled={this.state.disableEmail}
                            required
                          />
                        </div>


                        <div className="mb-3">
                          <AvField
                            name="password"
                            label={this.props.t("Password")}
                            type="password"
                            validate={{
                              required: { value: true, errorMessage: this.props.t("Please enter a password") },
                              pattern: { value: "^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?]{10,}$", errorMessage: 'Your password must be composed of letters, numbers, and some common special characters, and be at least 10 characters long' }
                             
                            }}

                            placeholder={this.props.t("Enter Password")}
                          />
                        </div>
                        <div className="mb-3">
                          <AvField
                            name="password1"
                            type="password"
                            label={this.props.t("Re-type Password")}
                            placeholder={this.props.t("Re-type Password")}
                            errorMessage={this.props.t("Enter Re-password")}
                            validate={{
                              required: { value: true, errorMessage: this.props.t("Please enter a password") },

                              /* minLength: { value: 9, errorMessage: 'Your password must be between 9 and 20 characters' },
                              maxLength: { value: 20, errorMessage: 'Your password must be between 9 and 20 characters' }, */
                              //  pattern: { value: "^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$", errorMessage: 'Your password must be composed with letter and numbers' },
                              match: { value: "password", errorMessage: this.props.t("Passwords do not match") },

                            }}

                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="invitation_code"
                            label={this.props.t("Invitation Code")}
                            value={this.state.code || ""}
                            disabled={this.state.disableCode}
                            className="form-control"
                            placeholder={this.props.t("Enter invitation code")}
                            errorMessage={this.props.t("Enter invitation code")}
                            type="text"
                            required
                          />
                        </div>



                        {/* <div className="mb-3">
                          <Label htmlFor="validationCustom03">
                            City
                          </Label>
                          <AvField
                            name="city"
                            type="text"
                            autoComplete="off"
                            placeholder="Enter city"
                            errorMessage="Enter city"
                            required
                          />
                        </div> */}
                        {/* <div className="mb-3">
                          <Label htmlFor="validationCustom03">
                            Agency localisation
                          </Label>
                          <div ><button
                            type="button"
                            className="btn btn-dark"
                            onClick={() => this.toggleViewModal()}
                          >
                            <i className="bx bx-map font-size-16 align-middle me-2"></i>
                            Location
                          </button>

                          </div>

                        </div> */}
                        {/* {this.state.userAddress && this.state.userCity ? */}

                        {/*  :null} */}

                        <div className="mt-4 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            {this.props.t("Register")}
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <p className="mb-0">
                            {this.props.t("By registering you agree to the Medios")}{" "}
                            <a href="https://medios.ma/terms" target="_blank" rel="noreferrer" className="text-primary">
                              {this.props.t("Terms of Use")}
                            </a>
                          </p>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    {this.props.t("Already have an account ?")}{" "}<br /><br />
                    <Link
                      to="/login"
                      className="fw-medium text-primary"
                    >
                      {" "}
                      {this.props.t("Login")}
                    </Link>{" "}
                  </p>
                  <p>
                    © {new Date().getFullYear()} Medios.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
      </React.Fragment>
    )
  }
}

Invitation.propTypes = {
  apiError: PropTypes.any,
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.any,
  registrationError: PropTypes.any,
  user: PropTypes.object,
  google: PropTypes.object,
  t:PropTypes.any
}

const mapStateToProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
  LoadingContainer: LoadingContainer,
  v: "3",
})(
  withTranslation()(Invitation)
)
